module.exports = __webpack_public_path__ + "04_long_gray.94f7c81b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_long_gray.png
// module id = rmqT
// module chunks = 0